import { use } from 'react';

import type { MediaManager } from '../components/providers/media-manager';

import { MediaManagerContext } from '../components/providers/media-manager';

/**
 * Custom React hook that returns the media manager.
 * Must be used within a MediaManagerProvider and wrapped in Suspense.
 */
export function useMediaManager(): MediaManager {
    const manager = use(MediaManagerContext);

    if (!manager) {
        throw new Error('useMediaManager must be used within a MediaManagerProvider');
    }

    return manager;
}
